var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from "react-query";
import { getUser, LoyaltyApi } from "@jti/rest-api";
export const useUsersPointsBalance = () => {
    return useQuery("usersPointsBalance", () => __awaiter(void 0, void 0, void 0, function* () {
        const { uuid, ciam_token } = getUser();
        const loyaltyApi = LoyaltyApi.init();
        const status = yield loyaltyApi.getStatus();
        if (uuid && ciam_token && status) {
            return yield loyaltyApi.getPoints(uuid, ciam_token);
        }
    }));
};
